import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'

type UpdateIssueIssueTypeBulkRequestBase = {
  ids: string[]
}

type UpdateIssueIssueTypeBulkRequestWithIssueTypeId = UpdateIssueIssueTypeBulkRequestBase & {
  issueTypeId: string
}

type UpdateIssueIssueTypeBulkRequestWithClearIssueType = UpdateIssueIssueTypeBulkRequestBase & {
  clearIssueType: true
}

export type UpdateIssueIssueTypeBulkRequest =
  | UpdateIssueIssueTypeBulkRequestWithIssueTypeId
  | UpdateIssueIssueTypeBulkRequestWithClearIssueType

type UpdateIssueIssueTypeBulkResponseData = {
  updateIssuesBulk: {
    jobId: string
  }
}

export type UpdateIssueIssueTypeBulkResponse = GraphQLResponse<UpdateIssueIssueTypeBulkResponseData>

export async function apiUpdateIssueIssueTypeBulk(
  request: UpdateIssueIssueTypeBulkRequest,
): Promise<UpdateIssueIssueTypeBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {ids: request.ids, queryId: UpdateIssuesBulk}

  if ('issueTypeId' in request) {
    body.issueTypeId = request.issueTypeId
  } else {
    body.clearIssueType = request.clearIssueType
  }
  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueIssueTypeBulkResponse>
}
